import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'inversify';
import { Symbols } from '@/symbols';
let SystematicService = class SystematicService {
    constructor(SystematicApi) {
        this.SystematicApi = SystematicApi;
    }
    getSqlListApi(queriesData) {
        const res = this.SystematicApi.getSqlList(queriesData);
        return res;
    }
};
SystematicService = __decorate([
    injectable(),
    __param(0, inject(Symbols.SystematicApi)),
    __metadata("design:paramtypes", [Object])
], SystematicService);
export { SystematicService };
